import GeoCoordinates from './GeoCoordinates';
export default GeoCoordinates;